export const path = "/master-tag-aluna";
export const component = () => import("./index.jsx");
export const sidebar = null;
